import React, { useState } from 'react'
import copy from 'copy-to-clipboard'

import ConsoleDialog from './ConsoleDialog'
import { getTransactionExplorerUrl, shortenCryptoValue } from './transactionFeedback'

function CopyRow({ icon, label, value, copyLabel, copiedLabel }) {
    const [copied, setCopied] = useState(false)
    if (!value) return null
    const handleCopy = () => {
        copy(value)
        setCopied(true)
        window.setTimeout(() => setCopied(false), 1800)
    }
    return <div className="console-success-receipt__row">
        <i className={`fa ${icon}`} aria-hidden="true" />
        <span>{label}</span>
        <strong title={value}>{shortenCryptoValue(value)}</strong>
        <button type="button" onClick={handleCopy} aria-label={copyLabel} title={copyLabel} data-copy-value={value}>
            <i className={`fa ${copied ? 'fa-check' : 'fa-copy'}`} aria-hidden="true" />
            <span className="console-success-receipt__copy-status" aria-live="polite">{copied ? copiedLabel : ''}</span>
        </button>
    </div>
}

export function TransactionSuccessContent({
    title,
    description,
    amount,
    symbol,
    amountLabel,
    wallet,
    txHash,
    t,
}) {
    const hasAmount = amount !== undefined && amount !== null && amount !== ''
    return <div className={`console-transaction-success ${hasAmount ? 'has-amount' : ''}`.trim()}>
        <div className="console-success-orbit" aria-hidden="true">
            <i className="fa fa-check" />
        </div>
        <div className="console-success-heading">
            <h3>{title}</h3>
            {description && <p>{description}</p>}
        </div>
        {hasAmount && <div className="console-success-amount">
            <span>{amountLabel}</span>
            <strong>{amount} {symbol}</strong>
        </div>}
        {(wallet || txHash) && <div className="console-success-receipt">
            <CopyRow icon="fa-wallet" label={t('钱包地址')} value={wallet} copyLabel={t('复制钱包地址')} copiedLabel={t('已复制')} />
            <CopyRow icon="fa-file-invoice" label={t('交易哈希')} value={txHash} copyLabel={t('复制交易哈希')} copiedLabel={t('已复制')} />
        </div>}
    </div>
}

export default function TransactionSuccessDialog({
    show,
    onClose,
    title,
    description,
    amount,
    symbol,
    amountLabel,
    wallet,
    txHash,
    chainId,
    t,
}) {
    const explorerUrl = getTransactionExplorerUrl(chainId, txHash)
    const footer = <>
        {explorerUrl && <a className="console-button" href={explorerUrl} target="_blank" rel="noreferrer">
            {t('查看交易')} <i className="fa fa-external-link-alt" aria-hidden="true" />
        </a>}
        <button type="button" className="console-button console-button--primary" onClick={onClose}>{t('完成')}</button>
    </>
    return <ConsoleDialog
        show={show}
        onClose={onClose}
        closeLabel={t('关闭')}
        title={title}
        description={t('交易已确认')}
        icon="fa-check"
        tone="success"
        className="console-dialog--transaction"
        bodyClassName="console-dialog__body--transaction"
        footer={footer}
    >
        <div className="console-transaction-rail" aria-label={t('交易进度')}>
            <span><i className="fa fa-check" />{t('链上确认')}</span>
            <i />
            <span><i className="fa fa-check" />{t('完成')}</span>
        </div>
        <TransactionSuccessContent
            title={title}
            description={description}
            amount={amount}
            symbol={symbol}
            amountLabel={amountLabel}
            wallet={wallet}
            txHash={txHash}
            t={t}
        />
    </ConsoleDialog>
}
